import React from "react";

export default function A(props: any) {
  const { children, target = "_blank", rel = "noreferer", ...rest } = props;
  return (
    <a rel={rel} target={target} {...rest}>
      {children}
    </a>
  );
}
